import util from '../util'

let controller = 'Agencias'

export default Object.assign({}, util.GetCrud(controller, null), {
  GetDigito: function (numeroAgencia) {
    return util.Axios.Get(controller + '/GetDigito', numeroAgencia)
  },
  GetCodigoAgenciaPadrao: function () {
    return util.Axios.Get(controller + '/GetCodigoAgenciaPadrao')
  }
})
